export default "__VITE_ASSET__BdheTY0i__"